import React, { useState, memo, useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "../styles/Home.css";
import { Link } from "react-router-dom";
import hero1 from "../images/heroimages/hero1.webp";
import hero2 from "../images/heroimages/hero2.webp";
import hero3 from "../images/heroimages/hero3.webp";

const HomePage = memo(() => {
  const [activeIndex, setActiveIndex] = useState(0);

  const slides = useMemo(
    () => [
      {
        webp: hero1,
        alt: "Students studying abroad",
      },
      {
        webp: hero2,
        alt: "University campus life",
      },
      {
        webp: hero3,
        alt: "International education opportunities",
      },
    ],
    [],
  );

  const heroMetrics = useMemo(
    () => [
      { value: "500+", label: "Universities" },
      { value: "40+", label: "Study Destinations" },
      { value: "95%", label: "Visa Success Rate" },
    ],
    [],
  );

  return (
    <section className="home-container" aria-label="Study abroad hero section">
      <Swiper
        modules={[Autoplay, EffectFade]}
        effect="fade"
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        }}
        loop={true}
        speed={1000}
        className="background-slider"
        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={slide.alt}>
            <picture
              className={`slide ${activeIndex === index ? "active" : ""}`}
            >
              <source srcSet={slide.webp} type="image/webp" />
              <img
                className="slide-image"
                src={slide.webp}
                alt={slide.alt}
                loading={index === 0 ? "eager" : "lazy"}
                fetchpriority={index === 0 ? "high" : "auto"}
                width="1600"
                height="900"
              />
            </picture>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="overlay"></div>

      <div className="hero-content">
        <span className="hero-eyebrow">Global Education. Local Guidance.</span>
        <h1 className="hero-title">
          Transforming the Future <br /> of Education
        </h1>
        <p className="hero-subtitle">
          Connect with 500+ universities worldwide. Your study abroad journey
          starts here.
        </p>

        <div className="hero-metrics">
          {heroMetrics.map((metric) => (
            <div key={metric.label} className="hero-metric">
              <strong>{metric.value}</strong>
              <span>{metric.label}</span>
            </div>
          ))}
        </div>

        <div className="hero-buttons">
          <Link to="/contact" className="hero-button-link">
            <button className="hero-button primary">
              🎓 I Want to Study Abroad
            </button>
          </Link>
        </div>

        <div className="hero-indicators" aria-hidden="true">
          {slides.map((slide, index) => (
            <span
              key={slide.alt}
              className={`hero-indicator ${activeIndex === index ? "active" : ""}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
});

export default HomePage;
